import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";

export const AddEmployee = () => {

  const location = useLocation()
  const managers = [
    { name: "Employee Manager", path: "/employee-manager" },
    { name: "Student Manager", path: "/student-manager" },
    { name: "Cold leads dump", path: "/nl-nc-student-manager" },
    { name: "College Manager", path: "/college-manager" },
    { name: "Course Manager", path: "/course-manager" },
    { name: "Admission Manager", path: "/admission-manager" }
  ];
  const navigate = useNavigate()
  const [employeeName, setEmployeeName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  
  const [permissions, setPermissions] = useState(
    managers.reduce((acc, manager) => {
      acc[manager.name] = { add: false, view: false, name: manager?.name, path: manager?.path };
      return acc;
    }, {})
  );

  const validateForm = () => {
    let newErrors = {};
    if (!employeeName.trim()) newErrors.name = "Employee name is required";
    if (!email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = "Invalid email format";
    if(location?.state?.type !== "edit"){
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!password) {
      newErrors.password = "Password is required.";
    } else if (!passwordRegex.test(password)) {
      newErrors.password =
        "Password must be at least 8 characters and include 1 uppercase, 1 lowercase, 1 number, and 1 special character.";
    }}
    
    const hasPermission = Object.values(permissions).some((perm) => perm.add || perm.view);
    if (!hasPermission) newErrors.permissions = "At least one permission must be selected";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlePermissionChange = (manager, permission) => {
    setPermissions((prev) => {
      console.log(prev, "prev")
      return {
        ...prev,
        [manager?.name]: { ...prev[manager?.name], [permission]: !prev[manager?.name][permission], name: manager?.name, path: manager?.path },
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = { name: employeeName, email, password, managers: permissions, role: "subadmin", _id: location?.state?.data?._id };
    try {
      await axios.post(location?.state?.type !== "edit" ? `${process.env.REACT_APP_BASE_URL}/create-sub-admin` : `${process.env.REACT_APP_BASE_URL}/edit-sub-admin`, formData,{
        headers: {
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("token")}`,
        },
      });
      setEmployeeName("");
      setEmail("");
      setPassword("");
      setPermissions(
        managers.reduce((acc, manager) => {
          acc[manager.name] = { add: false, view: false };
          return acc;
        }, {})
      );
      navigate("/employee-manager")
      setErrors({});
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };
  useEffect(()=>{
     if((location.pathname === "/view-employee" || location.pathname === "/edit-employee") && !location.state){
       navigate("/employee-manager")
     }
     if(location?.state?.type === "view" || location?.state?.type === "edit"){
      setEmployeeName(location?.state?.data?.name)
      setEmail(location?.state?.data?.email)
      // Merge existing permissions with default permissions for all managers
      const defaultPermissions = managers.reduce((acc, manager) => {
        acc[manager.name] = { add: false, view: false, name: manager?.name, path: manager?.path };
        return acc;
      }, {});
      const existingPermissions = location?.state?.data?.managers || {};
      setPermissions({...defaultPermissions, ...existingPermissions});
     }
  },[location])

  return (
    <div className="min-h-screen flex bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-6">
        <h1 className="text-2xl font-bold text-black mb-6"> {location?.state?.type === "view" ? "View Employee" : location?.state?.type === "edit" ? "Edit Employee" : "Add Employee"}</h1>
        <form onSubmit={handleSubmit} className="bg-white p-6 shadow-md rounded-lg">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div>
              <label className="block text-gray-700 font-semibold mb-2">Employee Name</label>
              <input type="text" value={employeeName} onChange={(e) => {
                setErrors(prev => {
                  return {...prev, name: ""}
                })
                setEmployeeName(e.target.value)}}
                placeholder="Enter employee name" 
                disabled={location?.state?.type === "view"}
                className="border border-gray-300 rounded-md px-4 py-2 w-full" />
              {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
            </div>
            <div>
              <label className="block text-gray-700 font-semibold mb-2">Email</label>
              <input type="email" value={email} onChange={(e) => {
                setErrors(prev => {
                  return {...prev, email: ""}
                })
                setEmail(e.target.value)}}
                placeholder="Enter employee email"
                disabled={location?.state?.type === "view"}
                className="border border-gray-300 rounded-md px-4 py-2 w-full" />
              {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
            </div>
            {location?.state?.type !== "view" && location?.state?.type !== "edit" && <div>
              <label className="block text-gray-700 font-semibold mb-2">Password</label>
              <input type="password" value={password} onChange={(e) => {
                setErrors(prev => {
                  return {...prev, password: ""}
                })
                setPassword(e.target.value)}}
                placeholder="Enter employee password" className="border border-gray-300 rounded-md px-4 py-2 w-full" />
              {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
            </div>}
          </div>
          <h2 className="text-lg font-bold text-black mb-4">Assign Permissions</h2>
          <div className="overflow-x-auto mb-6">
            <table className="table-auto w-full border-collapse border border-gray-300">
              <thead className="bg-blue text-white">
                <tr>
                  <th className="px-4 py-2 border border-gray-300">Manager</th>
                  <th className="px-4 py-2 border border-gray-300">Add / Edit</th>
                  <th className="px-4 py-2 border border-gray-300">View</th>
                </tr>
              </thead>
              <tbody>
                {managers.map((manager) => (
                 manager?.name !== "Employee Manager" && <tr key={manager.name}>
                    <td className="px-4 py-2 border border-gray-300">{manager.name}</td>
                    <td className="px-4 py-2 border border-gray-300 text-center">
                      <input type="checkbox" checked={permissions[manager.name]?.add}
                disabled={location?.state?.type === "view"}
                        onChange={() => {
                          setErrors(prev => {
                            return {...prev, permissions: ""}
                          })
                          if(permissions[manager.name]?.add){
                            handlePermissionChange(manager, "add")
                          }else{
                            handlePermissionChange(manager, "add")
                            if(!permissions[manager.name]?.view){
                            handlePermissionChange(manager, "view")
                            }
                          }
                          }} />
                    </td>
                    <td className="px-4 py-2 border border-gray-300 text-center">
                      <input type="checkbox" checked={permissions[manager.name]?.view}
                disabled={location?.state?.type === "view"}
                        onChange={() => {
                          setErrors(prev => {
                            return {...prev, permissions: ""}
                          })
                          if(permissions[manager.name]?.view){
                            handlePermissionChange(manager, "view")
                            if(permissions[manager.name]?.add){
                            handlePermissionChange(manager, "add")
                            }
                          }else{
                            handlePermissionChange(manager, "view")
                          }
                          }} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {errors.permissions && <p className="text-red-500 text-sm mt-2">{errors.permissions}</p>}
          </div>
          {location?.state?.type !== "view" && <button type="submit" className="bg-blue text-white px-6 py-2 rounded-md shadow-md">Submit</button>}
        </form>
      </div>
    </div>
  );
};